import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "account-apps-device";

@Injectable({
  providedIn: "root",
})
export class AccountAppDeviceHandlerService {
  constructor(private APIService: ApiService) {}

  filterCount(masterAccountID: number, appID: number, filter: any) {
    return this.APIService.post(
      `${PATH}/${masterAccountID}/app/${appID}/count`,
      filter,
    );
  }

  filter(masterAccountID: number, appID: number, filter: any) {
    return this.APIService.post(
      `${PATH}/${masterAccountID}/app/${appID}/filter`,
      filter,
    );
  }

  /**
   * Search v2 for Customer Roster results
   * Endpoint documented at client-integration.md: POST /account-apps-device/:master_account_id/app/:account_app_id/search
   * Body must conform to customer-roster-search.v1 schema
   */
  search(masterAccountID: number, appID: number, payload: any) {
    return this.APIService.post(
      `${PATH}/${masterAccountID}/app/${appID}/search`,
      payload,
    );
  }

  getAccountAppDevice(masterAccountID: number, accountAppDeviceID: String) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/device/${accountAppDeviceID}`,
    );
  }

  getAccountAppDeviceLocationHistory(masterAccountID: number, accountAppDeviceID: String) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/app_device/${accountAppDeviceID}/location-history`,
    );
  }

  getAccountAppDeviceSignalHistory(masterAccountID: number, accountAppDeviceID: String) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/app_device/${accountAppDeviceID}/signal-history`,
    );
  }

  getExecutiveSummary(
    masterAccountID: number,
    facilities?: number[],
    start?: Date,
    end?: Date,
  ) {
    let queryParams = "";
    if (facilities?.length || start || end) {
      queryParams = "?";
      let firstParam = true;
      if (facilities?.length) {
        for (let facilityID of facilities) {
          if (!firstParam) {
            queryParams = queryParams + "&";
          }
          queryParams = queryParams + "facility_id=" + facilityID;
          firstParam = false;
        }
      }
      if (start) {
        if (!firstParam) {
          queryParams = queryParams + "&";
        }
        queryParams = queryParams + "start=" + start.toISOString();
        firstParam = false;
      }
      if (end) {
        if (!firstParam) {
          queryParams = queryParams + "&";
        }
        queryParams = queryParams + "end=" + end.toISOString();
        firstParam = false;
      }
    }
    return this.APIService.get(
      `${PATH}/${masterAccountID}/app_device/executive-summary${queryParams}`,
    );
  }

  getRegions(masterAccountID: number, start: Date, end: Date, forExport: boolean) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/app_device/regions?start=${start.toISOString()}&end=${end.toISOString()}&forExport=${forExport}`,
    );
  }

  getDeviceInfo(
    masterAccountID: number,
    accountAppID: number,
    system: string,
    start: Date,
    end: Date,
  ) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/app/${accountAppID}/device_info?system=${system}&start=${start.toISOString()}&end=${end.toISOString()}`,
    );
  }

  getInsights(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/app/${accountAppID}/insights?start=${start.toISOString()}&end=${end.toISOString()}`,
    );
  }

  getInsightRedemptions(
    masterAccountID: number,
    accountAppID: number,
    signalID: number,
    signalType: string,
    start: Date,
    end: Date,
  ) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/app/${accountAppID}/insights/redemptions?start=${start.toISOString()}&end=${end.toISOString()}&signal_id=${signalID}&type=${signalType}`,
    );
  }

  getCustomerInsights(
    masterAccountID: number,
    facilities: number[],
    start: Date,
    end: Date,
  ) {
    let queryParams = "";
    if (facilities?.length || start || end) {
      queryParams = "?";
      let firstParam = true;
      if (facilities?.length) {
        for (let facilityID of facilities) {
          if (!firstParam) {
            queryParams = queryParams + "&";
          }
          queryParams = queryParams + "facility_id=" + facilityID;
          firstParam = false;
        }
      }
      if (start) {
        if (!firstParam) {
          queryParams = queryParams + "&";
        }
        queryParams = queryParams + "start=" + start.toISOString();
        firstParam = false;
      }
      if (end) {
        if (!firstParam) {
          queryParams = queryParams + "&";
        }
        queryParams = queryParams + "end=" + end.toISOString();
        firstParam = false;
      }
    }
    return this.APIService.get(
      `${PATH}/${masterAccountID}/app_device/customer-insights${queryParams}`,
    );
  }

}
